import { Card } from "@/components/ui/card";

import { PageContentHeader } from "@/components/PageContentHeader";
import { BlockList } from "@/components/BlockList";

export function BlocksPage() {
  return (
    <div className="flex container p-4 space-y-4 flex-col">
      <PageContentHeader title="Latest Blocks" />
      <Card className="overflow-hidden">
        <BlockList paginate={true} compact={false} />
      </Card>
    </div>
  );
}
